import { render, staticRenderFns } from "./UserProjectsList.vue?vue&type=template&id=da16e8b8&scoped=true"
import script from "./UserProjectsList.vue?vue&type=script&lang=js"
export * from "./UserProjectsList.vue?vue&type=script&lang=js"
import style0 from "./UserProjectsList.vue?vue&type=style&index=0&id=da16e8b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16e8b8",
  null
  
)

export default component.exports